import React from 'react';
import { NavLink } from 'react-router-dom';

import CreatePlaylistButton from '../CreatePlaylistButton';
import styles from './PlaylistField.module.scss';

function PlaylistField({ playlistOwner, className, actions }) {
  const { playlist } = playlistOwner || {};
  const { name } = playlist || {};

  return (
    <div className={className}>
      <div className="m-v-xxs">
        <div>
          <label className="hint">Cue Card</label>
          {playlistOwner && (
            <NavLink
              className="link h5 m-l-m"
              to="playlist"
              target="_blank"
              rel="noopener noreferrer"
            >
              Edit
            </NavLink>
          )}
          {actions}
        </div>
        {!playlistOwner && <div className="h5">No playlists yet</div>}
      </div>
      {playlistOwner && <div className={styles.playlistName}>{name}</div>}
      {!playlistOwner && <CreatePlaylistButton />}
    </div>
  );
}

export default PlaylistField;
